import { Spinner } from '@selfinspectionorg/ui-kit';
import colors from '@selfinspectionorg/ui-kit/css/colors.module.scss';
import styles from './FullscreenLoader.module.scss';

export const FullscreenLoader = () => {
  return (
    <div className={styles.wrapper}>
      <Spinner color={colors.selfInspection_600} width={40} height={40} />
    </div>
  );
};
